import React, { useState, useRef, useEffect } from "react";
import { OTPContainer } from "./Styles";
import { Center } from "../../../styles/component/style";
import { Otp } from "../../common/Otp/Otp";
import { Header } from "../../internal/Header/Header";
import { navigate } from "@reach/router";
import AuthService from "../../../services/AuthService";
import { getErrorMessage } from "../../../helpers/functions";
import { useSnackbar } from "notistack";
import _ from "lodash";
import useUser from "../../../hooks/useUser";
import useIfLoggedIn from "../../../hooks/useIfLoggedIn";
import useLoader from "../../../hooks/useLoader";
import labels from "../../../helpers/labels.json";

const Index = ({ location }) => {
  const [value, setValue] = useState("");
  const { state } = location;
  const { enqueueSnackbar } = useSnackbar();
  const { setToken } = useUser();
  useIfLoggedIn();
  const { setLoader } = useLoader();
  const codeRef = useRef(undefined);
  const [sending, setSending] = useState(false);
  const resendOtp = async () => {
    try {
      setLoader({ state: true });
      const response = await AuthService.verifications(state.payload);
      clearInputs();
      if (response) {
        enqueueSnackbar("OTP Sent Successfully", {
          variant: "success",
        });
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
      clearInputs();
      console.log(error);
    } finally {
      setLoader({ state: false });
    }
  };

  const clearInputs = () => {
    if (codeRef.current.textInput[0]) codeRef.current.textInput[0].focus();
    codeRef.current.state.input[0] = "";
    codeRef.current.state.input[1] = "";
    codeRef.current.state.input[2] = "";
    codeRef.current.state.input[3] = "";
    codeRef.current.state.input[4] = "";
    codeRef.current.state.input[5] = "";
  };
  const handleSubmit = async () => {
    try {
      setLoader({ state: true });
      setSending(true);
      let payload = _.pick(state.payload, ["mobile"]);
      payload.mobileToken = value;
      payload.idToken = state.idToken;
      const response = await AuthService.validateMobile(payload);
      if (response.message === "Invalid Verification!") {
        enqueueSnackbar("Invalid OTP", {
          variant: "error",
        });
      }
      if (response && response.token) {
        setToken(response.token);
        navigate("/create-profile");
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
      clearInputs();
      console.log(error);
    } finally {
      setValue("");
      setLoader({ state: false });
      setSending(false);
    }
  };

  useEffect(() => {
    const enterHandler = (event) => {
      if (!sending) {
        if (codeRef.current) {
          if (codeRef.current.state.value.length === 6) {
            if (event.key === "Enter") {
              handleSubmit();
            }
          }
        }
      }
    };
    window.addEventListener("keyup", enterHandler);
    return () => {
      window.removeEventListener("keyup", enterHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, codeRef]);

  const editTriggered = () => {
    if (state?.idToken) {
      navigate("/google-signup", {
        state: {
          payload: state?.payload,
          idToken: state.idToken,
          profileObj: state.profileObj,
        },
      });
    } else {
      navigate("/signup", {
        state: {
          payload: state.values,
        },
      });
    }
  };

  if (!state?.payload?.mobile) {
    navigate(-1);
  }
  return (
    <Header>
      <Center>
        <OTPContainer>
          <Otp
            heading={labels["onboarding.step2"]}
            disableSubmit={value.length < 6}
            submitLabel={labels.proceed}
            phoneNumber={`${state?.payload.mobile}`}
            timer={60}
            isTimmerEnabel={true}
            triggerResent={resendOtp}
            triggerEdit={editTriggered}
            numberOfInput={6}
            inputName="otp"
            value={value}
            setValue={setValue}
            handleSubmit={handleSubmit}
            codeRef={codeRef}
          />
        </OTPContainer>
      </Center>
    </Header>
  );
};

export default Index;
